import { useQuery } from 'react-query';

import api from '@Modules/Dashboard/services/api';

import processResponseError from '@System/api/processResponseError';

const useDashboardQuery = params => {
    return useQuery(['dashboard', params], () => api.getDashboard(params), {
        retry: false,
        onError: err => {
            processResponseError(err);
        },
    });
};

export default useDashboardQuery;
